var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DropdownSelect } from '@marketing/components/funnel/FormFields/DropdownSelect';
import { useState } from 'react';
function Quantity(_a) {
    var _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.handleQuantityChange, handleQuantityChange = _c === void 0 ? function () {
        console.log('handleQuantityChange not provided');
    } : _c, _d = _a.id, id = _d === void 0 ? 'select-quantity' : _d, _e = _a.initialValue, initialValue = _e === void 0 ? 1 : _e, _f = _a.maxQuantity, maxQuantity = _f === void 0 ? 50 : _f;
    var _g = useState(initialValue), currentValue = _g[0], setCurrentValue = _g[1];
    var handleChange = function (value) {
        setCurrentValue(Number(value));
        handleQuantityChange(Number(value));
    };
    return (_jsxs("div", __assign({ className: "w-16" }, { children: [_jsx("div", __assign({ className: "mb-3xs-m" }, { children: _jsx("label", __assign({ className: "text-xs-med-m md:text-xs-med-d", htmlFor: id }, { children: "Qty" })) })), _jsx(DropdownSelect, { disabled: disabled, id: id, onCard: true, options: Array.from({ length: maxQuantity }, function (_, i) { return i + 1; })
                    .map(String)
                    .map(function (value) { return ({
                    label: value,
                    value: value,
                }); }), value: currentValue.toString(), onChange: handleChange })] })));
}
export default Quantity;
